module.exports = __webpack_public_path__ + "static/media/6.6aa19f60.svg";